import { Injectable } from '@angular/core';
import { appSettings } from 'app/appSettings';
import { CustomerPermissionsMW } from 'app/core/store/session/customer-permissions/customer-permissions.interface';
import { logger } from 'app/core/util/logger';
import { CustomerSummaryMW } from '../../store/contract-details/customer-summary/customer-summary.interface';
import { CustomersTO } from '../../store/session/user-context/user-context.interface';
import { default as cachedCustomers } from './responses/searchCustomers';
import { RestService } from './rest.service';

@Injectable({ providedIn: 'root' })
export class CustomersRestService {
  constructor(private restService: RestService) { }

  getSoldTosForSalesOrganisation(salesOrganisationId: string): Promise<CustomersTO> {
    if (appSettings.USE_MOCK_REST_DATA) {
      logger.log('MOCK REST getUserContext');
      return Promise.resolve(cachedCustomers as CustomersTO);
    } else {
      return this.restService.get$$(`/Customer/searchCustomer?SalesOrganization=${salesOrganisationId}`);
    }
  }

  getShipTosForSoldTo(soldToId: string): Promise<CustomersTO> {
    if (appSettings.USE_MOCK_REST_DATA) {
      logger.log('MOCK REST getUserContext');
      return Promise.resolve(cachedCustomers as CustomersTO);
    } else {
      return this.restService.get$$(`/Customer/searchCustomer?CustomerNumber=${soldToId}&SortingColumn=customerName&SortingType=asc`);
    }
  }

  getCustomerSummary(selectedCustomerId: string): Promise<CustomerSummaryMW> {
    return this.restService.get$$<CustomerSummaryMW>(`/Customer/getCustomerSummary?CustomerId=${selectedCustomerId}`);
  }

  getCustomerPermissions(): Promise<CustomerPermissionsMW> {
    return this.restService.get$$<CustomerPermissionsMW>(`/Customer/checkCustomerPermissions`);
  }

  getValutaForCustomer(customerIds: string[]) {
    const params = {
      CustomerNumbers: customerIds,
    };
    return this.restService.post(`/Customer/getValutaForCustomers`, params);
  }

  private async dumpSoldTosShipTosToJsonForDevelopment(salesOrganisationId: string) {
    const result = await this.restService.get$$<CustomersTO>(`/Customer/searchCustomer?SalesOrganization=${salesOrganisationId}`)
    const soldTos = [];
    debugger;
    for (let i = 0; i < result.items.length; i++) {
      const soldTo = result.items[i];
      logger.log(`[${i + 1}/${result.items.length}] fetch soldTo ${soldTo.customerName}`);
      try {
        const shipTos = await this.getShipTosForSoldTo(soldTo.customerNumber);
        soldTos.push({
          id: soldTo.customerNumber,
          name: soldTo.customerName,
          shipTos: shipTos.items.map(shipTo => {
            return {
              id: shipTo.customerNumber,
              name: shipTo.customerName,
            }
          })
        })
      } catch (error) {
        console.error(`failed to load shipTos`);
      }
    }

    logger.log(soldTos);
    return result;

  }
}
